import { render } from "./viewClientComponent.vue?vue&type=template&id=4650316a&scoped=true"
import script from "./viewClientComponent.vue?vue&type=script&lang=js"
export * from "./viewClientComponent.vue?vue&type=script&lang=js"

import "./viewClientComponent.vue?vue&type=style&index=0&id=4650316a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4650316a"]])

export default __exports__